import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import './WaitBehaviorModal.css';

const WaitBehaviorModal = ({ isOpen, onClose, onSave }) => {
  const [duration, setDuration] = useState(0);
  const [withLocation, setWithLocation] = useState(false);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  const handleSave = () => {
    const behavior = {
      type: 'wait',
      duration: parseFloat(duration) || 0
    };

    if (withLocation) {
      const lat = parseFloat(latitude);
      const lon = parseFloat(longitude);
      if (isNaN(lat) || isNaN(lon)) {
        alert('Please enter valid coordinates');
        return;
      }
      behavior.latitude = lat;
      behavior.longitude = lon;
    }
    // If without location, we don't add the coordinate keys

    onSave(behavior);
    // Reset form
    setDuration(0);
    setWithLocation(false);
    setLatitude('');
    setLongitude('');
  };

  const handleCancel = () => {
    onClose();
    // Reset form
    setDuration(0);
    setWithLocation(false);
    setLatitude('');
    setLongitude('');
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel} title="Add Wait Behavior">
      <div className="wait-behavior-modal">
        <div className="wait-form">
          <div className="form-group">
            <label htmlFor="duration">Duration (seconds)</label>
            <input
              id="duration"
              type="number"
              min="0"
              step="0.1"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              className="duration-input"
              placeholder="Enter duration in seconds"
            />
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={withLocation}
                onChange={(e) => setWithLocation(e.target.checked)}
                className="location-checkbox"
              />
              <span>Wait with location</span>
            </label>
          </div>

          {withLocation && (
            <div className="location-inputs">
              <div className="form-group">
                <label htmlFor="latitude">Latitude</label>
                <input
                  id="latitude"
                  type="number"
                  step="0.000001"
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                  className="coordinate-input"
                  placeholder="e.g., 39.6061"
                />
              </div>
              <div className="form-group">
                <label htmlFor="longitude">Longitude</label>
                <input
                  id="longitude"
                  type="number"
                  step="0.000001"
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                  className="coordinate-input"
                  placeholder="e.g., -106.3550"
                />
              </div>
            </div>
          )}

          <div className="modal-actions">
            <Button
              variant="outline"
              size="medium"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              size="medium"
              onClick={handleSave}
              disabled={!duration || duration <= 0}
            >
              Add
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WaitBehaviorModal;
